var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60449 1.3938H10.1372V0.427734H11.6372V1.3938H14.4557C14.5109 1.3938 14.5557 1.43857 14.5557 1.4938V13.034C14.5557 13.0893 14.5109 13.134 14.4557 13.134H0.377344C0.322116 13.134 0.277344 13.0893 0.277344 13.034V1.4938C0.277344 1.43857 0.322115 1.3938 0.377344 1.3938H3.10449V0.427734H4.60449V1.3938ZM3.10449 2.8938H1.77734V4.50391H13.0557V2.8938H11.6372V3.77246H10.1372V2.8938H4.60449V3.77246H3.10449L3.10449 2.8938ZM13.0557 6.00391H1.77734V11.634H13.0557V6.00391Z",
    fill: "#164A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60449 1.3938H10.1372V0.427734H11.6372V1.3938H14.4557C14.5109 1.3938 14.5557 1.43857 14.5557 1.4938V13.034C14.5557 13.0893 14.5109 13.134 14.4557 13.134H0.377344C0.322116 13.134 0.277344 13.0893 0.277344 13.034V1.4938C0.277344 1.43857 0.322115 1.3938 0.377344 1.3938H3.10449V0.427734H4.60449V1.3938ZM3.10449 2.8938H1.77734V4.50391H13.0557V2.8938H11.6372V3.77246H10.1372V2.8938H4.60449V3.77246H3.10449L3.10449 2.8938ZM13.0557 6.00391H1.77734V11.634H13.0557V6.00391Z",
    stroke: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.1bd20628ef7d67e262ddf4fafe2af179.svg";
export { ForwardRef as ReactComponent };